import { Switch } from "@headlessui/react";
import { FC } from "react";
import { cn } from "../lib/utils";

export type SliderProps = {
	testId?: string;
	enabled: boolean;
	onChange: (newValue: boolean) => void;
	offLabel?: string;
	onLabel?: string;
	className?: string;
};

/**
 * @deprecated Use the `Toggle` primitive from `@portal/components/primitives/Toggle`
 * instead. `Toggle` shares this visual style, adds `color`/`size` variants and a built-in
 * clickable `label` slot, and follows the primitives contract (ref-as-prop, CVA, trackingId).
 */
export const Slider: FC<SliderProps> = ({
	testId,
	enabled,
	onChange,
	offLabel,
	onLabel,
	className,
}) => (
	<>
		{offLabel && <span>{offLabel}</span>}
		<Switch
			data-testid={testId ?? "slider"}
			checked={enabled}
			onChange={onChange}
			className={cn(
				"inline-flex h-6 w-11 items-center shrink-0 cursor-pointer rounded-full bg-surface-dark border-2 border-transparent transition-colors duration-200 ease-in-out",
				enabled && "bg-brand-accent",
				className,
			)}
		>
			<span
				aria-hidden="true"
				className={cn(
					"pointer-events-none inline-block h-5 w-5 transform rounded-full bg-surface-base shadow-lg ring-0 transition duration-200 ease-in-out",
					enabled ? "translate-x-5" : "translate-x-0",
				)}
			/>
		</Switch>
		{onLabel && <span>{onLabel}</span>}
	</>
);
